import { type FC } from 'react';
import LockIcon from '@assets/img/icons/lock.svg?react';
import { type NextBuild } from '@common/types/userType.ts';
import { NextIntroBuildItem } from '@components/Home/IntroTasks/NextIntroBuildItem/NextIntroBuildItem.tsx';
import ResourceCard from '@components/Home/IntroTasks/ResourceCard/ResourceCard.tsx';

import styles from './IntroTasks.module.css';

import furnitureicon from '/img/icons/factory_icons/furniture.png';
import lumberIcon from '/img/resources/boards.png';
import woodIcon from '/img/resources/tab-wood.png';
import shineImg from '/img/shineProfile.png';

const NextBuilds = [
  { id: 1, plant: 'wood', level: 1 },
  { id: 2, plant: 'lumber', level: 1 },
  { id: 3, plant: 'furniture_factory', level: 1 },
] as NextBuild[];

const IntroTasks: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className="absolute left-1/2 -translate-x-1/2 z-0 w-full h-full pointer-events-none">
          <img
            src={shineImg}
            alt=""
            className="absolute top-[-30%] w-full scale-y-[0.8] scale-x-[1.0] aspect-[43/39] opacity-70 object-contain"
          />
          <div className="absolute left-1/2 top-[100%] -translate-x-1/2 -translate-y-1/2 w-[100%] h-[60%] rounded-full bg-[radial-gradient(circle,_rgba(153,85,255,1)_30%,_transparent_80%)] blur-[35px]" />

          <div className="absolute left-1/2 top-[106%] -translate-x-1/2 -translate-y-1/2 w-[45%] h-[30%] rounded-full bg-[radial-gradient(circle,_rgba(153,85,255,1)_100%,_transparent_100%)] blur-[13px]" />
          <div className="absolute left-1/2 top-[106%] -translate-x-1/2 -translate-y-1/2 w-[25%] h-[30%] rounded-full bg-[radial-gradient(circle,_rgba(239,239,239,0.3)_100%,_transparent_100%)] blur-[8px]" />
        </div>
        <div className="flex items-center gap-4 ml-4">
          {/* <img src={lockIcon} alt="" className="w-[32px] h-[32px]" /> */}
          <LockIcon className="w-8 h-8" />
          <div className="font-bold text-base tracking-normal leading-tight text-left">
            Requirements to
            <br />
            unlock Contracts
          </div>
        </div>
        <div className={styles.cards}>
          <div className={styles.cardLeft}>
            <ResourceCard
              starCount={2}
              image={woodIcon}
              current={0}
              total={200}
            />
          </div>
          <div className={styles.cardCenter}>
            <ResourceCard
              starCount={3}
              image={lumberIcon}
              current={0}
              total={200}
            />
          </div>
          <div className={styles.cardRight}>
            <ResourceCard
              starCount={5}
              image={furnitureicon}
              current={0}
              total={100}
            />
          </div>
        </div>
      </div>

      <div className={styles.section}>
        {NextBuilds.map((build) => (
          <NextIntroBuildItem key={build.id} {...build} />
        ))}
      </div>
    </div>
  );
};

export { IntroTasks };
